const CAP18 = {
  "id": 41,
  "title": "Cómo enviar y recibir  Bitcoin",
  "slug": "como-enviar-bitcoin",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "Introducción: enviar Bitcoin es simple",
      "text": [
        "Enviar Bitcoin es un proceso sencillo, comparable a enviar un correo electrónico.",
        "La red Bitcoin está disponible las 24 horas, todos los días del año. No cierra fines de semana, festivos ni tiene horarios restringidos.",
        "No existen intermediarios como bancos, ni comisiones de mantenimiento, ni se comercia con tu información personal."
      ]
    },
    {
      "heading": "¿Qué necesitas para enviar Bitcoin?",
      "list": [
        "Tener saldo disponible en tu monedero (wallet).",
        "Contar con la dirección pública del destinatario.",
        "Definir la cantidad de BTC o satoshis a enviar.",
        "Confirmar los datos y autorizar la transacción."
      ]
    },
    {
      "heading": "Proceso general para enviar Bitcoin",
      "text": [
        "Independientemente del tipo de monedero utilizado (web, app, hardware), los pasos para enviar Bitcoin suelen ser los mismos:"
      ],
      "list": [
        "1. Acceder a tu monedero y seleccionar la opción “Enviar” o “Transferir”.",
        "2. Introducir la dirección de destino (copiada, pegada o escaneada mediante QR).",
        "3. Ingresar la cantidad que se desea enviar en BTC o su equivalente en moneda local.",
        "4. Revisar los datos: dirección, monto y comisión de red.",
        "5. Confirmar para transmitir la transacción a la red."
      ]
    },
    {
      "heading": "Direcciones Bitcoin y códigos QR",
      "text": [
        "Las direcciones Bitcoin son cadenas largas de números y letras que identifican al destinatario.",
        "Para evitar errores, se recomienda copiarlas y pegarlas o escanear códigos QR, en lugar de escribirlas manualmente."
      ]
    },
    {
      "heading": "Confirmaciones y seguridad",
      "text": [
        "Una vez enviada la transacción, esta se propaga por la red y los mineros se encargan de verificarla e incluirla en un bloque.",
        "Cada validación se conoce como confirmación. Algunas plataformas permiten utilizar los fondos con 1 confirmación, otras solicitan 3 o más.",
        "Estas confirmaciones garantizan que la transacción es válida, irreversible y segura."
      ]
    },
    {
      "heading": "Transacciones entre usuarios de una misma plataforma",
      "text": [
        "Cuando el envío se realiza entre monederos pertenecientes a la misma plataforma, algunas aplicaciones permiten transferencias instantáneas y sin comisiones.",
        "Estas operaciones no se registran directamente en la blockchain, sino que ocurren en sistemas internos, como capa adicional (segunda capa) sobre Bitcoin."
      ]
    },
    {
      "heading": "Comisiones y elección de velocidad",
      "text": [
        "Las comisiones de la red (fees) se pagan a los mineros para procesar la transacción.",
        "No dependen de la cantidad enviada, sino del tamaño de la transacción en bytes.",
        "Algunas wallets permiten elegir entre envío económico (más lento) o prioridad (más rápido y con mayor fee)."
      ]
    },
     {
      "heading": "¿Cómo recibir Bitcoin?",
      "text": [
        "Recibir Bitcoin es muy fácil. Solo necesitas compartir tu dirección Bitcoin (en texto o en código QR) con la persona que te enviará los fondos.",
        "No necesitas pedir autorización a nadie. Simplemente compartes tu dirección y la otra persona podrá enviarte los bitcoin desde su monedero."
      ]
    },
    {
      "heading": "¿Cómo compartir mi dirección?",
      "text": ["Puedes compartir tu dirección Bitcoin de muchas maneras:"],
      "list": [
        "📄 Mostrar tu dirección en tu página web.",
        "📱 Mostrar el código QR de tu monedero en tu smartphone.",
        "🎥 Colocarla en la descripción de tus videos de YouTube.",
        "🎫 Imprimirla en flyers para donaciones o eventos.",
        "✉️ Compartirla por correo electrónico o redes sociales.",
        "🪪 Usarla como firma en foros o comunidades."
      ]
    },
    {
      "heading": "¿Dónde encuentro mi dirección Bitcoin?",
      "text": [
        "Solo debes ingresar a tu monedero (wallet).",
        "Allí verás tu dirección en formato de texto y también como un código QR para escanear. Además, puedes generar nuevas direcciones si lo deseas."
      ]
    },
    {
      "heading": "Sobre la privacidad",
      "text": [
        "En la blockchain toda la información es pública. Si reutilizas siempre la misma dirección, cualquier persona podría ver cuánto has recibido y tu historial.",
        "Por eso, es una buena práctica generar una dirección nueva cada vez que vayas a recibir un pago."
      ]
    },
    {
      "heading": "¿Qué ocurre cuando recibes un pago?",
      "text": [
        "Cuando alguien te envía bitcoin, la transacción aparecerá inmediatamente en tu monedero como 'pendiente' o 'sin confirmar'.",
        "Después de 2 confirmaciones (aprox. 20 minutos), podrás usar tus fondos libremente."
      ]
    },
    {
      "heading": "¿Qué puedes hacer con tus bitcoin recibidos?",
      "list": [
        "Enviar a otra persona o servicio.",
        "Intercambiar por otras criptomonedas.",
        "Vender por dinero fiat como euros, dólares o pesos.",
        "Guardarlos como inversión.",
        "Moverlos a una wallet más segura (hardware, paper wallet, etc.)."
      ]
    },
    {
      "heading": "Historial y control de movimientos",
      "text": [
        "Tu monedero también dispone de un historial de transacciones para ver todos los detalles de cada operación. Incluso puedes añadir notas personalizadas."
      ]
    },
    {
      "heading": "Resumen general",
      "list": [
        "Bitcoin se puede enviar a cualquier parte del mundo y en cualquier momento.",
        "Solo necesitas una dirección de destino y saldo disponible.",
        "No hay intermediarios ni necesitas autorización de terceros.",
        "Las comisiones suelen ser bajas y la velocidad dependerá de la congestión de la red.",
        "Una vez confirmada, la transacción es segura, válida e irreversible."
      ]
    }
  ]
};

export default CAP18;
